import { Link } from "react-router-dom";
import AnimatedSection from "../../../components/base/AnimatedSection";
import { blogArticles } from "../../../mocks/blog";

const articles = blogArticles.slice(0, 3);

export default function BlogPreview() {
  return (
    <section id="blog" className="py-24" style={{ backgroundColor: "#F4F4F4" }}>
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection>
          <div className="flex items-center gap-4 mb-4">
            <div className="w-8 h-0.5" style={{ backgroundColor: "#E8150C" }}></div>
            <span className="font-body text-brand-red text-sm font-medium tracking-widest uppercase">
              Recursos y guias
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
            <div>
              <h2 className="font-heading font-black text-brand-black leading-none"
                style={{ fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
                BLOG — GESTION DEPORTIVA AMATEUR
              </h2>
              <p className="font-body text-brand-gray-mid mt-3 text-sm">
                Recursos y guias para organizadores que quieren profesionalizar su competicion.
              </p>
            </div>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
          {articles.map((article, i) => (
            <AnimatedSection key={article.slug} delay={i * 100}>
              <Link
                to={`/blog/${article.slug}`}
                className="bg-white rounded-lg overflow-hidden group hover:border-brand-red border border-transparent transition-all duration-300 cursor-pointer h-full flex flex-col"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{ objectPosition: article.imagePosition ?? "center top" }}
                  />
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <span className="font-body text-xs font-medium text-brand-red tracking-widest uppercase mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-heading font-bold text-brand-black text-xl leading-tight mb-3 tracking-tight">
                    {article.title}
                  </h3>
                  <p className="font-body text-brand-gray-mid text-sm leading-relaxed flex-1 mb-5">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between mt-auto">
                    <span className="font-body text-brand-gray-mid text-xs">{article.readTime}</span>
                    <span className="font-body text-brand-red text-sm font-medium group-hover:underline whitespace-nowrap">
                      Leer mas →
                    </span>
                  </div>
                </div>
              </Link>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection delay={200}>
          <div className="flex justify-center mt-12">
            <Link
              to="/blog"
              className="bg-brand-red hover:bg-brand-red-hover text-white font-body font-medium px-10 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              Ver todos los articulos
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
